{
  "title": "autobrr",
  "username": "Brukernavn",
  "password": "Passord",
  "confirmPassword": "Bekreft passord",
  "createAccount": "Opprett konto",
  "rememberMe": "Husk meg",
  "forgotPassword": "Glemt passord?",
  "forgotPasswordHelp": "Tilbakestill via terminal:",
  "signIn": "Logg inn",
  "continueWith": "Eller fortsett med",
  "openidConnect": "OpenID Connect",
  "errors": {
    "required": "Påkrevd",
    "usernameRequired": "Brukernavn er påkrevd",
    "passwordRequired": "Passord er påkrevd",
    "passwordsDoNotMatch": "Passordene stemmer ikke overens!",
    "generic": "En feil oppstod!",
    "oidcFailed": "OIDC-autentisering feilet"
  }
}
